<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="isCreate"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="this.$route.params.id"
  />
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import { VCheckbox, VTextField } from 'vuetify/lib'
  import RegionDataService from '@/services/api/RegionDataService'
  import TimezoneSelectField from '@/components/ui/crud/fields/TimezoneSelectField'

  export default {
    components: { EntityEditForm },
    data () {
      return {
        title: 'Новый регион',
        isCreate: true,
        listRouteName: 'regionsList',
        dataService: RegionDataService,
        fields: [
          { key: 'name', label: 'Название', component: VTextField, defaultValue: null, rules: ['required'] },
          { key: 'namePadeg', label: 'Название в падеже', component: VTextField, rules: ['required'], defaultValue: null },
          { key: 'slug', label: 'Код региона (поддомен)', component: VTextField, rules: ['required'], defaultValue: null },
          { key: 'timeZone', label: 'Часовой пояс', component: TimezoneSelectField, rules: ['required'], defaultValue: null },

          { key: 'mapCenter', label: 'Координаты центра карты доставки', component: VTextField, defaultValue: '55.755819, 37.617644' },
          { key: 'mapZoom', label: 'Масштаб (zoom) карты доставки', component: VTextField, rules: ['number'], defaultValue: 5 },
          { key: 'zoneRadius', label: 'Радиус зоны (км)', component: VTextField, rules: ['number'] },
          { key: 'phone', label: 'Телефон для сайта', component: VTextField, defaultValue: null },
          { key: 'workTimeString', label: 'Режим работы, отображаемый на сайте', component: VTextField, defaultValue: '10:00-23:00' },
          { key: 'vk', label: 'Адрес группы Вконтакте', component: VTextField, defaultValue: null },
          { key: 'sortOrder', label: 'Индекс сортировки', component: VTextField, rules: ['requiredNumber'], defaultValue: 100 },
          { key: 'status', label: 'Регион активен', component: VCheckbox, defaultValue: true },
        ],
      }
    },

  }
</script>
